/**
 * Per-account inbound PIX same-origin lock.
 *
 *   GET  /v1/accounts/{id}/inbound-pix-origin-lock   accounts.read
 *   PUT  /v1/accounts/{id}/inbound-pix-origin-lock   Valut admin + accounts.write
 */

import { baasProxy } from "./baasConsoleClient";

export const mapAccountInboundPixOriginLockToUi = (api) => {
  if (!api) return null;
  return {
    accountId: api.account_id || api.accountId || "",
    enabled: Boolean(api.enabled),
    lockedOriginDocument: api.locked_origin_document || api.lockedOriginDocument || "",
    editable: Boolean(api.editable),
    instanceLockEnabled: Boolean(api.instance_lock_enabled ?? api.instanceLockEnabled),
    raw: api,
  };
};

export const fetchAccountInboundPixOriginLock = async (instance, accountId, options = {}) => {
  if (!instance || !accountId) return null;
  const data = await baasProxy({
    instance,
    method: "GET",
    baasPath: `v1/accounts/${encodeURIComponent(accountId)}/inbound-pix-origin-lock`,
    signal: options.signal,
  });
  return mapAccountInboundPixOriginLockToUi(data);
};

export const putAccountInboundPixOriginLock = async (
  instance,
  accountId,
  body,
  options = {},
) => {
  if (!instance || !accountId) {
    throw new Error("Instance and accountId are required.");
  }
  const payload = {};
  if (typeof body?.enabled === "boolean") payload.enabled = body.enabled;
  if (body?.lockedOriginDocument !== undefined) {
    payload.locked_origin_document = body.lockedOriginDocument ?? "";
  }
  const data = await baasProxy({
    instance,
    method: "PUT",
    baasPath: `v1/accounts/${encodeURIComponent(accountId)}/inbound-pix-origin-lock`,
    body: payload,
    signal: options.signal,
  });
  return mapAccountInboundPixOriginLockToUi(data);
};
